import './CollectionsCard.scss'

import { HDSButton, HDSProgressIndicator } from '@here/hds-react-components'
import { i18n } from 'lib/i18n'
import React from 'react'

import { CollectionCategory } from '../util/collection-category'
import OverviewImage from './collections-overview.svg'
import CollectionTile from './CollectionTile/CollectionTile'

interface CollectionsCardProps {
  collections: Item[]
  footerAction: FooterAction
  onActionClick?: (action: Action) => void
  onSelect?: (id: string) => void
  isLoading?: boolean
}

export enum FooterAction {
  login = 'sign-in',
  add = 'add',
}

export enum Action {
  login = 'sign-in',
  add = 'add',
  seeAll = 'seeAll',
}

export interface Item {
  id: string
  name: string
  count: number
  category: CollectionCategory
}

export default function CollectionsCard({
  collections,
  footerAction,
  isLoading,
  onActionClick,
  onSelect,
}: CollectionsCardProps): JSX.Element {
  const overviewDescription = i18n('collections.collections-card.content.preview')
  const footerTitle =
    footerAction === FooterAction.login
      ? i18n('collections.collections-card.actions.sign-in')
      : i18n('collections.collections-card.actions.new-collection')
  const seeAll = i18n('collections.collections-card.header.action')
  const title = i18n('collections.collections-card.header.title')

  return (
    <div className="CollectionsCard">
      <div className="CollectionsCard__container">
        <div className="CollectionsCard__header">
          <div className="CollectionsCard__title">{title}</div>
          {collections !== undefined && collections.length > 0 && (
            <a
              onClick={() => onActionClick && onActionClick(Action.seeAll)}
              className="CollectionsCard__expand"
            >
              {seeAll}
            </a>
          )}
        </div>
        <div className="CollectionsCard__content">
          {isLoading !== undefined && isLoading ? (
            <HDSProgressIndicator
              className="CollectionsCard__loading"
              color="accent"
              size="small"
              variant="indeterminate"
              indicatorType="circular"
            />
          ) : collections !== undefined && collections.length > 0 ? (
            collections
              ?.slice(0, 3)
              .map((collection) => (
                <CollectionTile
                  onClick={(id) => onSelect !== undefined && onSelect(id)}
                  key={collection.id}
                  name={collection.name}
                  id={collection.id}
                  count={collection.count}
                  category={collection.category}
                />
              ))
          ) : (
            <div className="CollectionsCard__overview">
              <img
                className="CollectionsCard__overview-img"
                src={OverviewImage}
                alt="Overview Image"
              ></img>
              <div className="CollectionsCard__overview-text">{overviewDescription}</div>
            </div>
          )}
        </div>
        <div className="CollectionsCard__divider"></div>
        <div className="CollectionsCard__footer">
          <HDSButton
            variant="link"
            size="medium"
            icon={footerAction}
            onClick={() => onActionClick && onActionClick(footerAction as unknown as Action)}
          >
            {footerTitle}
          </HDSButton>
        </div>
      </div>
    </div>
  )
}
